import { getMoodLabel } from '../utils/getRecommendations';

function MoodSelector({ onSelect, selectedMood }) {
  const moods = ['happy', 'sad', 'stressed', 'tired', 'calm', 'sick'];

  return (
    <section className="py-8">
      <h2 className="text-2xl font-semibold text-gray-900 mb-6 text-center">
        How are you feeling right now?
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {moods.map((mood) => (
          <button
            key={mood}
            onClick={() => onSelect(mood)}
            className={`p-4 rounded-xl border transition-all cursor-pointer ${
              selectedMood === mood
                ? 'bg-black text-white border-black'
                : 'bg-white text-gray-800 border-gray-200 hover:bg-gray-50 hover:border-gray-300'
            }`}
          >
            <div className="text-2xl mb-1">{getMoodLabel(mood).split(' ')[0]}</div>
            <div className="text-sm font-medium">{getMoodLabel(mood).split(' ').slice(1).join(' ')}</div>
          </button>
        ))}
      </div>
    </section>
  );
}

export default MoodSelector;
